import script from "./AnnouncementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementDetail.vue?vue&type=style&index=0&id=618b821d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618b821d"]])

export default __exports__